import { render, staticRenderFns } from "./AidexToC.vue?vue&type=template&id=57854d25&scoped=true&"
import script from "./AidexToC.vue?vue&type=script&lang=js&"
export * from "./AidexToC.vue?vue&type=script&lang=js&"
import style0 from "./AidexToC.vue?vue&type=style&index=0&id=57854d25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57854d25",
  null
  
)

export default component.exports